module.exports = __webpack_public_path__ + "img/aidmodel_xl.7e022f79.png";